<template>
  <!-- Modal "podepsat dokument" -->
  <div class="modal fade" id="podpisovyModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form>
          <div class="modal-header">
            <h4 class="modal-title">{{ podpisProps.title }}</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body">
            <p>
            Datum: {{ human_readable_today() }}
            </p>
            <p>
              <label for="signed-name" class="control-label">{{ podpisProps.caption }}</label>
              <input type="text" class="form-control" id="signed-name" v-model="signedName" :disabled="signInProgress" disabled>
            </p>

            <div class="row" v-if="displayError">
              <div class="col-lg-12">
                <div class="alert alert-danger" role="alert">
                  <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Chyba při podepisování dokumentu<br/>{{ displayError }}
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <div class="d-flex w-100">
              <div class="flex-grow-1 text-left">
                <button type="button" class="btn btn-outline=default" data-dismiss="modal" :disabled="signInProgress">
                  Zpět
                </button>
              </div>
              <div>
                <button type="submit" class="btn btn-primary" v-on:click="podepsatDokument()" :disabled="signInProgress">
                  Podepsat dokument
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import $ from 'jquery';
import AgreementResource from '../backend-resources/agreement-resource'

export default {
  name: 'agreementSign',
  data: () => {
    return {
      signedName: '',
      signInProgress: false,
      displayError: null,
    }
  },
  props: [ 'podpisProps' ],
  created: function() {
    this.signedName = this.prefillSignedName();
  },
  mounted: function () {
    // automaticky zobrazit modal
    $('#podpisovyModal').modal('show');
    // focus do policka "jmeno"
    $('#podpisovyModal').on('shown.bs.modal', (e) => {
      $('input#signed-name').focus();
    })
    // pri uzavreni emitovat nahoru do komponentu Agreement
    $('#podpisovyModal').on('hidden.bs.modal', (e) => {
      console.log('modal hidden');
      this.$emit('modal-hidden');
    })
  },
  computed: {
    incompleteForm () {
      return this.inputUsername === '' || this.inputPassword === ''
    },
  },
  methods: {
    prefillSignedName () {
      console.log(this.$store.state.customerInfo)
      /* právnická osoba */
      if (this.$store.state.customerInfo.type == 1) {
        return this.$store.state.customerInfo.statutar || '';
      }
      /* fyzická osoba */
      return `${this.$store.state.customerInfo.name || ''} ${this.$store.state.customerInfo.lastname || ''}`.trim();
    },
    human_readable_today: function () {
      return moment().format('D.M.Y')
    },
    podepsatDokument: function() {
      console.log('podepsat');

      this.signInProgress = true;

      AgreementResource.sign(this.podpisProps.id, this.podpisProps.seq, this.signedName).then((response) => {
        this.displayError = null;
        this.signInProgress = false;
        this.podepsatDokumentFinish();
      }).catch((error) => {
        this.displayError = error.response.status + ' ' + error.response.statusText
        this.signInProgress = false;
      })

    },
    podepsatDokumentFinish: function () {
      this.$emit('document-sign-finished');
      $('#podpisovyModal').modal('hide')
    }
  },
}
</script>

<style scoped>
.form-control#signed-name {
  padding-top: 1.0em;
  padding-bottom: 1.0em;
  font-size: 150%;
  font-family: cursive;
}
</style>



// WEBPACK FOOTER //
// AgreementSign.vue?4fd430b8